import { createLoader, parseAsArrayOf, parseAsStringEnum } from 'nuqs/server';

enum PhaseTypes {
  Planned = 'Planerat',
  UnderSale = 'Under försäljning',
  SoldOut = 'Slutsålt',
  Removed = 'Borttaget',
}

const DEFAULT_PHASE_TYPES = [PhaseTypes.UnderSale];

type PhaseColor = {
  className: string;
  cssVar: string;
};

export enum DetailedPhaseTypes {
  Planned = 'Planerade',
  ForSale = 'Till salu',
  Reserved = 'Reserverade',
  Booked = 'Bokade',
  Sold = 'Sålda',
  Removed = 'Borttagna',
}
type DetailedPhaseColor = { hex: string };

export const detailedPhaseColorMap: Record<DetailedPhaseTypes, DetailedPhaseColor> = {
  [DetailedPhaseTypes.Planned]: { hex: '#1155ee' },
  [DetailedPhaseTypes.ForSale]: { hex: '#118834' },
  [DetailedPhaseTypes.Reserved]: { hex: '#e8a800' },
  [DetailedPhaseTypes.Booked]: { hex: '#e05c00' },
  [DetailedPhaseTypes.Sold]: { hex: '#dd3322' },
  [DetailedPhaseTypes.Removed]: { hex: '#1a1a1a' },
};

export const phaseColorMap: Record<PhaseTypes, PhaseColor> = {
  [PhaseTypes.Planned]: {
    className: 'bg-bui-color-blue',
    cssVar: 'var(--bui-color-blue)',
  },
  [PhaseTypes.UnderSale]: {
    className: 'bg-bui-color-green',
    cssVar: 'var(--bui-color-green)',
  },
  [PhaseTypes.SoldOut]: {
    className: 'bg-bui-color-red',
    cssVar: 'var(--bui-color-red)',
  },
  [PhaseTypes.Removed]: {
    className: 'bg-bui-color-black',
    cssVar: 'var(--bui-color-black)',
  },
};

const keyMaps = {
  phase: parseAsArrayOf(parseAsStringEnum(Object.values(PhaseTypes))).withDefault(DEFAULT_PHASE_TYPES),
};
const urlKeys = {
  phase: 'phase',
};
const phaseLoader = createLoader(keyMaps, { urlKeys });

export { DEFAULT_PHASE_TYPES, keyMaps, PhaseTypes, phaseLoader, urlKeys };
